module.exports = __webpack_public_path__ + "static/media/swirePayIcon.a5817875.svg";